import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthHelperService {
  private readonly authService = inject(MsalService);

  /**
   * Check if the idToken contains roles with the Administrator Claim
   * @returns boolean true, if the user has the role of Administrator
   */
  public get isAdmin(): boolean {
    const roles = this.authService.instance.getAllAccounts()?.[0]?.idTokenClaims?.roles;
    return roles?.includes('Administrator');
  }
}
